import { Controller } from '@hotwired/stimulus'
import { pingDevice } from '../services/asset_api'

const MONITOR_INTERVAL = 10000
const MAX_PINGS = 300 / (MONITOR_INTERVAL / 1000)

export default class extends Controller {
  static targets = ['statusLight'];

  connect () {
    this.monitors = new Map()
    this.pingAllAssets()
  }

  disconnect () {
    this.monitors.forEach((_, assetId) => {
      this.stopPingMonitor(assetId)
    })
  }

  ping (event) {
    const assetId = event.currentTarget.dataset.assetId
    this.executePing(assetId)
  }

  pingMonitor (event) {
    const button = event.currentTarget
    const assetId = button.dataset.assetId

    if (this.monitors.has(assetId)) {
      this.stopPingMonitor(assetId)
    } else {
      this.startPingMonitor(assetId, button)
    }
  }

  pingAllAssets () {
    this.statusLightTargets.forEach((el) => {
      const assetId = el.dataset.assetId
      if (assetId) {
        this.executePing(assetId)
      }
    })
  }

  async executePing (assetId) {
    const statusEl = this.findStatusLight(assetId)
    if (!statusEl) return

    this.getStatus(statusEl, 'pending')
    const result = await pingDevice(assetId)

    if (result && result.success) {
      this.getStatus(statusEl, 'online')
    } else {
      this.getStatus(statusEl, 'offline')
    }
  }

  findStatusLight (assetId) {
    return this.statusLightTargets.find(
      (el) => el.dataset.assetId === String(assetId)
    )
  }

  getStatus (el, status) {
    el.className = ''
    if (status === 'pending') {
      el.classList.add('status-light-pending')
    } else {
      el.classList.add('status-light', `status-light-${status}`)
    }
  }

  startPingMonitor (assetId, button) {
    this.executePing(assetId)
    let remaining = MAX_PINGS - 1

    button.textContent = `Cancel (${remaining})`
    button.classList.remove('btn-secondary')
    button.classList.add('btn-danger')

    const intervalId = setInterval(() => {
      this.executePing(assetId)
      remaining--
      button.textContent = `Cancel (${remaining})`

      if (remaining <= 0) {
        this.stopPingMonitor(assetId)
      }
    }, MONITOR_INTERVAL)

    this.monitors.set(assetId, { intervalId, button })
  }

  stopPingMonitor (assetId) {
    const monitor = this.monitors.get(assetId)
    if (!monitor) return

    clearInterval(monitor.intervalId)
    monitor.button.textContent = 'Monitor'
    monitor.button.classList.remove('btn-danger')
    monitor.button.classList.add('btn-secondary')
    this.monitors.delete(assetId)
  }
}
